import { createSlice } from "@reduxjs/toolkit";
import { fetchDashboardMetricsReducer } from "../../reducer/dashboard/fetchDashboardMetricsReducer";
import i18n from "../../i18n";
const initialState = {
  data: null,
  isLoading: false,
  error: null,
  // requestId of the most recent fetch. Only that request may write the result, so a slow
  // earlier response (e.g. "From only" while the user is still picking "To", or the
  // Dashboard's all-time fetch) can never overwrite the figures for the current filter.
  latestRequestId: null,
};
const dashboardMetricsSlice = createSlice({
  name: "dashboardMetrics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardMetricsReducer.pending, (state, action) => {
        state.latestRequestId = action.meta.requestId;
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardMetricsReducer.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.data = action.payload || null;
      })
      .addCase(fetchDashboardMetricsReducer.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadDashboardMetrics");
        // Don't leave the previous filter's figures on screen as if they matched this one.
        state.data = null;
      });
  },
});
export default dashboardMetricsSlice.reducer;
